var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"co-col gap pa-0 w"},_vm._l((_vm.keyNumbers),function(k){return _c('li',{key:k.label,staticClass:"co-col"},[_c('span',{staticClass:"text-huge"},[_vm._v(_vm._s(k.value))]),_c('span',[_vm._v(_vm._s(k.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }